import { useNavigate } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import { LifeBuoy } from "lucide-react";
import { Button } from "@/components/ui/button";
import { supabase } from "@/integrations/supabase/client";
import { useSupportSession } from "@/hooks/useSupportSession";
import { toast } from "sonner";

/** Fixed banner shown on every screen while a platform admin is in support mode. */
export function SupportModeBanner() {
  const { session } = useSupportSession();
  const qc = useQueryClient();
  const navigate = useNavigate();
  const [busy, setBusy] = useState(false);
  if (!session) return null;

  const minsLeft = Math.max(0, Math.round((new Date(session.expires_at).getTime() - Date.now()) / 60000));

  const exit = async () => {
    setBusy(true);
    const { error } = await supabase.rpc("admin_end_support" as any);
    setBusy(false);
    if (error) return toast.error("Couldn't exit support mode. Try again.");
    await qc.invalidateQueries();
    navigate(`/admin/workspaces/${session.org_id}`);
  };

  return (
    <div
      role="status"
      className="sticky top-0 z-[60] flex items-center justify-between gap-3 border-b border-destructive/40 bg-destructive text-destructive-foreground px-4 py-2 text-sm"
    >
      <span className="flex items-center gap-2 min-w-0">
        <LifeBuoy className="w-4 h-4 shrink-0" />
        <span className="truncate">
          Support mode: <strong>{session.org_name}</strong>. Everything you do is logged.
        </span>
        <span className="hidden sm:inline opacity-80">Ends in {minsLeft} min.</span>
      </span>
      <Button size="sm" variant="secondary" onClick={exit} disabled={busy}>
        Exit
      </Button>
    </div>
  );
}
